export default "__VITE_ASSET__BkLBx7cZ__"